import { useMutation, useQuery } from "@tanstack/react-query";
import { backendApi } from "./api.service";
import { AddRequest, RejectRequest, SolveRequest } from "@/types";

type PaginationRequest = {
  page?: number;
  pageSize?: number;
  name?: string;
};

export const useGetAllRequests = (pagination: PaginationRequest) => {
  const config = { withCredentials: true, params: pagination };
  return useQuery({
    queryKey: ["get-requests", pagination],
    queryFn: () => backendApi.get("/request/get-requests", config),
  });
};

export const useRejectRequest = () => {
  const config = { withCredentials: true };
  return useMutation({
    mutationFn: (data: RejectRequest) =>
      backendApi.patch("/request/reject-request", data, config),
  });
};

export const useRespondRequest = () => {
  const config = { withCredentials: true };
  return useMutation({
    mutationFn: (data: SolveRequest) =>
      backendApi.patch(`/request/solve-request`, data, config),
  });
};

export const addRequest = async (data: AddRequest) => {
  const config = { withCredentials: true };
  try {
    const response = await backendApi.post(
      `/request/add-request`,
      data,
      config,
    );
    return response.data;
  } catch (error) {
    console.error("Error adding request:", error);
    throw error; // Rethrow the error to handle it where you call this function
  }
};
